import type { AircraftSpec, PilotProfile } from "./types";

/** Hawker 800XP type designator — Emerson’s current rating. */
export const HAWKER_ICAO_TYPE = "H25B";
export const PC12_ICAO_TYPE = "PC12";

/** Software vendor that built the dispatch product. */
export const SOFTWARE_VENDOR = "Northstar";

/**
 * Emerson’s personal fiction operator — catalog tails / Celtic saves only.
 * Never mint / Brain / Classic origin truth after company create.
 */
export const FICTION_OPERATOR_NAME = "Celtic Air Services";
export const FICTION_HOME_ICAO = "CYPD";

/**
 * In-app fallback for inbox / Grok copy when no company name is set.
 * First-run suggests {@link SUGGESTED_COMPANY_NAME} — neither is locked.
 */
export const OPERATOR_NAME = "Company";

/** Editable first-run prefill. Operator-agnostic — user types the shop name. */
export const SUGGESTED_COMPANY_NAME = "Company";

/** First-run home is empty until the user picks. Never force CYPD after create. */
export const SUGGESTED_HOME_ICAO = "";

export const DEFAULT_PILOT: PilotProfile = {
  name: "",
  pilotNumber: "",
  phone: "",
  email: "",
  ratedIcaoTypes: [HAWKER_ICAO_TYPE],
};

export function normalizeRatedTypes(types?: string[]): string[] {
  const list = (types ?? []).map((t) => t.trim().toUpperCase()).filter(Boolean);
  return list.length ? [...new Set(list)] : [HAWKER_ICAO_TYPE];
}

export function aircraftMatchesRatings(spec: AircraftSpec, ratedIcaoTypes?: string[]): boolean {
  const rated = normalizeRatedTypes(ratedIcaoTypes);
  return rated.includes(spec.icaoType.toUpperCase());
}

export function ratedFleet(fleet: AircraftSpec[], ratedIcaoTypes?: string[]): AircraftSpec[] {
  return fleet.filter(
    (a) => a.available && (a.status ?? "available") === "available" && aircraftMatchesRatings(a, ratedIcaoTypes),
  );
}

/** Auto-assignment: rated + legal only. Does not fall back to unrated tails (PC-12). */
export function pickAssignedAircraft(
  candidates: AircraftSpec[],
  ratedIcaoTypes?: string[],
  preferredId?: string,
): AircraftSpec | undefined {
  const rated = candidates.filter((a) => aircraftMatchesRatings(a, ratedIcaoTypes));
  if (preferredId) {
    const hit = rated.find((a) => a.id === preferredId);
    if (hit) return hit;
  }
  return rated[0];
}
